import Vue from 'vue'
import Router from 'vue-router'
import RoomObject from '@/components/RoomObject'
import StartScreen from '@/components/StartScreen'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: StartScreen
    },
    {
      path: '/start',
      component: StartScreen
    },
    {
      path: '/:id',
      component: RoomObject
    }

  ]
})
